import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  deleteRoom,
  getFloor,
  addRoom,
  updateRoom,
} from "../../../../actions/adminAction";
import Alert from "../../../../layouts/Alert";

import { useDispatch, useSelector } from "react-redux";
import FloorImage from "./FloorImage";
import { useReducer } from "react";

// your forceUpdate hook
// const useForceUpdate = () => {
//   const [value, setValue] = useState(0); // integer state
//   return () => setValue((value) => value + 1); // update the state to force render
// };

const RoomList = ({ id }) => {
  const navigate = useNavigate();
  // const forceUpdate = useForceUpdate();
  const [, forceUpdate] = useReducer((x) => x + 1, 0);
  const dispatch = useDispatch();
  const floor = useSelector((state) => state.admin.floor);
  const floorLoading = useSelector((state) => state.admin.floorLoading);
  const [mapArea, setMapArea] = useState();
  const [room, setRoom] = useState(null);
  const [edit, setEdit] = useState(null);
  const [preview, setPreview] = useState({
    id: null,
    Room: "",
    leftPin: "0",
    topPin: "0",
    height: "0",
    width: "0",
    r: "0",
    g: "0",
    b: "0",
    camera_Direction: "",
    front_Desc: "",
    right_Desc: "",
    back_Desc: "",
    left_Desc: "",
  });

  useEffect(() => {
    if (room !== null) {
      setPreview({
        id: room ? floor.rooms.find((r) => r.id === room).id : null,
        Room: room ? floor.rooms.find((r) => r.id === room).Room : "",
        leftPin: room
          ? parseFloat(
              floor.rooms.find((r) => r.id === room).leftPin.replace("%", "")
            )
          : "0",
        topPin: room
          ? parseFloat(
              floor.rooms.find((r) => r.id === room).topPin.replace("%", "")
            )
          : "0",
        height: room
          ? parseFloat(
              floor.rooms.find((r) => r.id === room).height.replace("%", "")
            )
          : "0",
        width: room
          ? parseFloat(
              floor.rooms.find((r) => r.id === room).width.replace("%", "")
            )
          : "0",
        r: room
          ? Number(floor.rooms.find((r) => r.id === room).color.split(",")[0])
          : "0",
        g: room
          ? Number(floor.rooms.find((r) => r.id === room).color.split(",")[1])
          : "0",
        b: room
          ? Number(floor.rooms.find((r) => r.id === room).color.split(",")[2])
          : "0",
        camera_Direction: room
          ? floor.rooms.find((r) => r.id === room).camera_Direction
          : "",
        front_Desc: room
          ? floor.rooms.find((r) => r.id === room).front_Desc
          : "",
        right_Desc: room
          ? floor.rooms.find((r) => r.id === room).right_Desc
          : "",
        back_Desc: room ? floor.rooms.find((r) => r.id === room).back_Desc : "",
        left_Desc: room ? floor.rooms.find((r) => r.id === room).left_Desc : "",
      });
    }
  }, [room]);
  useEffect(() => {
    if (floor === null && floorLoading) {
      dispatch(getFloor(id));
    }
  }, [floor, floorLoading, getFloor, id]);

  useEffect(() => {
    if (floor) {
      if (floor.rooms) {
        setMapArea(
          floor.rooms.map((room) => {
            return {
              ...room,
              left: room.leftPin,
              top: room.topPin,
              style: {
                background: `rgba(${room.color}, 0.1)`,
                border: `2px solid rgb(${room.color})`,
              },
              selected: true,
            };
          })
        );
      }
    }
  }, [floor]);

  useEffect(() => {
    if (mapArea) {
      setMapArea([
        ...(mapArea.length > floor.rooms.length
          ? mapArea.slice(0, -1)
          : mapArea),
        {
          ...preview,
          color: `${preview.r}, ${preview.g}, ${preview.b}`,
          height: preview.height + "%",
          width: preview.width + "%",
          left: preview.leftPin + "%",
          top: preview.topPin + "%",
          style: {
            background: `rgba(${preview.r}, ${preview.g}, ${preview.b}, 0.1)`,
            border: `2px solid rgb(${preview.r}, ${preview.g}, ${preview.b})`,
          },
          selected: true,
        },
      ]);
      forceUpdate();
    }
  }, [preview, setPreview]);

  const onChange = (e) => {
    setPreview({ ...preview, [e.target.id]: e.target.value });
  };

  return (
    <Fragment>
      {/* Delete Modal  */}
      <div
        className="modal fade"
        id="deleteRoom"
        aria-labelledby="deleteRoomLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content admin-list">
            <div className="modal-header">
              <h5 className="modal-title" id="deleteRoomLabel">
                Delete Room
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              Are you sure you want to delete room?
              <br />
              <br />
              <b>
                <span className="text-danger text-center">
                  Warning Deleting a Room will result in deleting everything
                  related to it
                </span>
              </b>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn admin-list-btn-secondary text-white"
                onClick={() => {
                  dispatch(deleteRoom(room, floor.id));
                }}
                data-bs-dismiss="modal"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Update Room Modal */}
      <div
        className="modal fade"
        id="updateRoom"
        aria-labelledby="updateRoomLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div className="modal-content admin-list">
            <div className="modal-header">
              <h5 className="modal-title" id="updateRoomLabel">
                Update Room
              </h5>
              <button
                type="button"
                className="btn-close btn-close-white"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  setRoom(null);
                  setPreview({
                    id: null,
                    Room: "",
                    leftPin: "0",
                    topPin: "0",
                    height: "0",
                    width: "0",
                    r: "0",
                    g: "0",
                    b: "0",
                    camera_Direction: "",
                    front_Desc: "",
                    right_Desc: "",
                    back_Desc: "",
                    left_Desc: "",
                  });
                }}
              ></button>
            </div>
            <div
              className="modal-body"
              onClick={(e) => {
                e.preventDefault();
              }}
            >
              {/* Edit Room Form Content */}
              <form
                className="w-100 p-2 p-sm-3 p-lg-4 shadow-lg mb-2 d-flex gap-5"
                style={{ minHeight: "400px" }}
              >
                {/* Fields */}
                <>
                  {/* Room Setting */}
                  <div className="w-50 d-flex flex-column">
                    {/* ID */}
                    <div className="mb-3">
                      <div className="txt-primary">ID {""}</div>
                      <input
                        type="text"
                        className="form-control rounded "
                        id="id"
                        value={preview.id}
                        placeholder="Enter Name..."
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* Name */}
                    <div className="mb-3">
                      <div className="txt-primary">Name {""}</div>
                      <input
                        type="text"
                        className="form-control rounded "
                        id="Room"
                        value={preview.Room}
                        placeholder="Enter Name..."
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* Left Pin */}
                    <div className="mb-3">
                      <div className="txt-primary">Left</div>
                      <input
                        type="number"
                        className="form-control rounded "
                        id="leftPin"
                        placeholder="Enter Left Pin..."
                        required
                        value={preview.leftPin}
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* Top Pin */}
                    <div className="mb-3">
                      <div className="txt-primary">Top</div>
                      <input
                        type="number"
                        className="form-control rounded "
                        id="topPin"
                        placeholder="Enter Top Pin..."
                        required
                        value={preview.topPin}
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* Height */}
                    <div className="mb-3">
                      <div className="txt-primary">Height</div>
                      <input
                        type="number"
                        className="form-control rounded "
                        id="height"
                        placeholder="Enter Height..."
                        required
                        value={preview.height}
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* Width */}
                    <div className="mb-3">
                      <div className="txt-primary">Width</div>
                      <input
                        type="number"
                        className="form-control rounded "
                        id="width"
                        placeholder="Enter Width..."
                        required
                        value={preview.width}
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* Color */}
                    <div className="mb-3">
                      <div className="txt-primary">Color</div>
                      <div className="d-flex flex-row gap-3">
                        <input
                          width="10px"
                          type="number"
                          className="form-control rounded "
                          id="r"
                          min="0"
                          max="255"
                          placeholder="Red"
                          required
                          value={preview.r}
                          onChange={(e) => onChange(e)}
                        />
                        <input
                          width="10px"
                          type="number"
                          className="form-control rounded "
                          id="g"
                          min="0"
                          max="255"
                          placeholder="Green"
                          required
                          value={preview.g}
                          onChange={(e) => onChange(e)}
                        />
                        <input
                          width="5px"
                          type="number"
                          className="form-control rounded "
                          id="b"
                          min="0"
                          max="255"
                          placeholder="Blue"
                          required
                          value={preview.b}
                          onChange={(e) => onChange(e)}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Robot Setting */}
                  <div className="w-50 d-flex flex-column">
                    {/* Robot Facing */}
                    <div className="mb-3">
                      <div className="txt-primary">Robot Facing</div>
                      <select
                        className="form-control rounded"
                        id="camera_Direction"
                        value={preview.camera_Direction}
                        onChange={(e) => onChange(e)}
                      >
                        <option value=""></option>
                        <option value="Front">Front</option>
                        <option value="Back">Back</option>
                        <option value="Left">Left</option>
                        <option value="Right">Right</option>
                      </select>
                    </div>

                    {/* Front Description */}
                    <div className="mb-3">
                      <div className="txt-primary">Front Description</div>
                      <input
                        type="text"
                        className="form-control rounded "
                        id="front_Desc"
                        value={preview.front_Desc}
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* Right Description */}
                    <div className="mb-3">
                      <div className="txt-primary">Right Description</div>
                      <input
                        type="text"
                        className="form-control rounded "
                        id="right_Desc"
                        value={preview.right_Desc}
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* Back Description */}
                    <div className="mb-3">
                      <div className="txt-primary">Back Description</div>
                      <input
                        type="text"
                        className="form-control rounded "
                        id="back_Desc"
                        value={preview.back_Desc}
                        onChange={(e) => onChange(e)}
                      />
                    </div>

                    {/* Left Description */}
                    <div className="mb-3">
                      <div className="txt-primary">Left Description</div>
                      <input
                        type="text"
                        className="form-control rounded "
                        id="left_Desc"
                        value={preview.left_Desc}
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                  </div>
                </>
              </form>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => {
                  setRoom(null);
                  setPreview({
                    id: null,
                    Room: "",
                    leftPin: "0",
                    topPin: "0",
                    height: "0",
                    width: "0",
                    r: "0",
                    g: "0",
                    b: "0",
                    camera_Direction: "",
                    front_Desc: "",
                    right_Desc: "",
                    back_Desc: "",
                    left_Desc: "",
                  });
                }}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn admin-list-btn-secondary text-white"
                onClick={() => {
                  console.log("Update Room", room, preview);
                  dispatch(
                    updateRoom(room, {
                      id: preview.id,
                      Room: preview.Room,
                      leftPin: preview.leftPin + "%",
                      topPin: preview.topPin + "%",
                      height: preview.height + "%",
                      width: preview.width + "%",
                      color: `${preview.r}, ${preview.g}, ${preview.b}`,
                      floors_id: id,
                      camera_Direction: preview.camera_Direction,
                      front_Desc: preview.front_Desc,
                      right_Desc: preview.right_Desc,
                      back_Desc: preview.back_Desc,
                      left_Desc: preview.left_Desc,
                    })
                  );
                  setPreview({
                    id: null,
                    Room: "",
                    leftPin: "0",
                    topPin: "0",
                    height: "0",
                    width: "0",
                    r: "0",
                    g: "0",
                    b: "0",
                    camera_Direction: "",
                    front_Desc: "",
                    right_Desc: "",
                    back_Desc: "",
                    left_Desc: "",
                  });
                }}
                data-bs-dismiss="modal"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="px-sm-5 py-sm-4 p-2 admin-margin h-100 w-100 me-0 mt-0 mb-0 text-main text-center">
        <div className="mb-2">
          <div className="d-flex align-items-center my-2">
            <h6 className="text-main text-center mb-0">
              Admin / Floors / Floor / Rooms
            </h6>
          </div>
          <div className="d-sm-flex  w-100 align-items-center justify-content-between">
            <div className="d-flex mb-2 mb-sm-0 align-items-center">
              <div
                className="admin-back mx-2  rounded-circle border border-2 d-flex align-items-center justify-content-center "
                onClick={() => {
                  navigate(-1);
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="18"
                  height="18"
                  fill="currentColor"
                  className="bi bi-arrow-left-short"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
                  />
                </svg>
              </div>
              <h4 className="m-0">Rooms</h4>
            </div>
          </div>
        </div>

        {floor && (
          <>
            <div>
              <Alert />
            </div>
            <div className="card w-100 h-100 p-2 p-sm-3 p-lg-4 shadow-lg border-0 admin-list mb-2 d-flex flex-lg-row flex-column overflow-auto">
              <div className="col col-lg-4 overflow-auto">
                <FloorImage
                  // rooms={[...floor.rooms, preview]}
                  mapArea={mapArea}
                  image={floor.image}
                />
              </div>
              {/* Add Room Form + Previews */}
              <div className="col col-lg-8 px-3">
                <div className="row mx-2">
                  <div className="text-truncate col">Name</div>
                  <div className="text-truncate col">Left</div>
                  <div className="text-truncate col">Top</div>
                  <div className="text-truncate col">Height</div>
                  <div className="text-truncate col">Width</div>
                  <div className="text-truncate col">Color</div>
                  <div className="text-truncate col">Robot Facing</div>
                  <div className="text-truncate col">Front Description</div>
                  <div className="text-truncate col">Right Description</div>
                  <div className="text-truncate col">Back Description</div>
                  <div className="text-truncate col">Left Description</div>
                  <div className="text-truncate col"></div>
                </div>
                <div className="row border-bottom py-3 mx-2">
                  {/* Room Name */}
                  <div className="text-truncate px-1 col">
                    <input
                      type="text"
                      className="form-control rounded admin-list text-main text-center"
                      id="Room"
                      placeholder="Enter Name..."
                      required
                      value={preview.Room}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  {/* Left Pin */}
                  <div className="text-truncate px-1 col">
                    <input
                      type="number"
                      className="form-control rounded admin-list text-main text-center"
                      id="leftPin"
                      placeholder="Enter Left Pin..."
                      required
                      value={preview.leftPin}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  {/* Top Pin */}
                  <div className="text-truncate px-1 col">
                    <input
                      type="number"
                      className="form-control rounded admin-list text-main text-center"
                      id="topPin"
                      placeholder="Enter Top Pin..."
                      required
                      value={preview.topPin}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  {/* Height */}
                  <div className="text-truncate px-1 col">
                    <input
                      type="number"
                      className="form-control rounded admin-list text-main text-center"
                      id="height"
                      min="0"
                      placeholder="Enter Height..."
                      required
                      value={preview.height}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  {/* Width */}
                  <div className="text-truncate px-1 col">
                    <input
                      type="number"
                      className="form-control rounded admin-list text-main text-center"
                      id="width"
                      min="0"
                      placeholder="Enter Width..."
                      required
                      value={preview.width}
                      onChange={(e) => onChange(e)}
                    />
                  </div>
                  {/* Color */}
                  <div className="text-truncate px-1 col">
                    <div className="input-group">
                      <input
                        type="number"
                        className="form-control p-1  admin-list text-main text-center"
                        id="r"
                        min="0"
                        max="255"
                        required
                        value={preview.r}
                        onChange={(e) => onChange(e)}
                      />
                      <input
                        type="number"
                        className="form-control p-1  admin-list text-main text-center text-center"
                        id="g"
                        min="0"
                        max="255"
                        required
                        value={preview.g}
                        onChange={(e) => onChange(e)}
                      />
                      <input
                        type="number"
                        className="form-control p-1  admin-list text-main text-center"
                        id="b"
                        min="0"
                        max="255"
                        required
                        value={preview.b}
                        onChange={(e) => onChange(e)}
                      />
                    </div>
                  </div>
                  {/* Robot Facing */}
                  <div className="text-truncate px-1 col">
                    <select
                      className="form-control rounded admin-list text-main text-center"
                      id="camera_Direction"
                      value={preview.camera_Direction}
                      onChange={(e) => onChange(e)}
                    >
                      <option value=""></option>
                      <option value="Front">Front</option>
                      <option value="Back">Back</option>
                      <option value="Left">Left</option>
                      <option value="Right">Right</option>
                    </select>
                  </div>

                  {/* Front Description */}
                  <div className="text-truncate px-1 col">
                    <input
                      type="text"
                      className="form-control rounded admin-list text-main text-center"
                      id="front_Desc"
                      value={preview.front_Desc}
                      onChange={(e) => onChange(e)}
                    />
                  </div>

                  {/* Right Description */}
                  <div className="text-truncate px-1 col">
                    <input
                      type="text"
                      className="form-control rounded admin-list text-main text-center"
                      id="right_Desc"
                      value={preview.right_Desc}
                      onChange={(e) => onChange(e)}
                    />
                  </div>

                  {/* Back Description */}
                  <div className="text-truncate px-1 col">
                    <input
                      type="text"
                      className="form-control rounded admin-list text-main text-center"
                      id="back_Desc"
                      value={preview.back_Desc}
                      onChange={(e) => onChange(e)}
                    />
                  </div>

                  {/* Left Description */}
                  <div className="text-truncate px-1 col">
                    <input
                      type="text"
                      className="form-control rounded admin-list text-main text-center"
                      id="left_Desc"
                      value={preview.left_Desc}
                      onChange={(e) => onChange(e)}
                    />
                  </div>

                  {/* Add Room */}
                  <div className="text-truncate px-1 col">
                    <button
                      disabled={preview.Room === ""}
                      className="w-100 btn admin-list-btn-secondary p-1 text-main text-center"
                      onClick={() => {
                        if (preview.Room !== "") {
                          dispatch(
                            addRoom({
                              Room: preview.Room,
                              leftPin: preview.leftPin + "%",
                              topPin: preview.topPin + "%",
                              height: preview.height + "%",
                              width: preview.width + "%",
                              color: `${preview.r}, ${preview.g}, ${preview.b}`,
                              floors_id: id,
                              camera_Direction: preview.camera_Direction,
                              front_Desc: preview.front_Desc,
                              right_Desc: preview.right_Desc,
                              back_Desc: preview.back_Desc,
                              left_Desc: preview.left_Desc,
                            })
                          );
                          setPreview({
                            Room: "",
                            leftPin: "0",
                            topPin: "0",
                            height: "0",
                            width: "0",
                            r: "0",
                            g: "0",
                            b: "0",
                            camera_Direction: "",
                            front_Desc: "",
                            right_Desc: "",
                            back_Desc: "",
                            left_Desc: "",
                          });
                        }
                      }}
                    >
                      Add
                    </button>
                  </div>
                </div>
                <div className="row border-bottom py-3 mx-2">
                  <div className="text-truncate col">ID</div>
                  <div className="text-truncate col">Name</div>
                  <div className="text-truncate col">Left</div>
                  <div className="text-truncate col">Top</div>
                  <div className="text-truncate col">Height</div>
                  <div className="text-truncate col">Width</div>
                  <div className="text-truncate col">Color</div>
                  <div className="text-truncate col">Robot Facing</div>
                  <div className="text-truncate col">Front Description</div>
                  <div className="text-truncate col">Right Description</div>
                  <div className="text-truncate col">Back Description</div>
                  <div className="text-truncate col">Left Description</div>
                  <div className="text-truncate col"></div>
                </div>

                {/* Previews */}
                <div
                  className="w-100"
                  style={{ maxHeight: "400px", overflowY: "scroll" }}
                >
                  {floor.rooms?.map((room) => (
                    <div className="row border-bottom py-3 mx-2 fs-6">
                      <div className="text-truncate col" title={room.id}>
                        {room.id}
                      </div>
                      <div className="text-truncate col" title={room.Room}>
                        {room.Room}
                      </div>
                      <div className="text-truncate col" title={room.leftPin}>
                        {room.leftPin}
                      </div>
                      <div className="text-truncate col" title={room.topPin}>
                        {room.topPin}
                      </div>
                      <div className="text-truncate col" title={room.height}>
                        {room.height}
                      </div>
                      <div className="text-truncate col" title={room.width}>
                        {room.width}
                      </div>
                      <div
                        className="text-truncate col"
                        title={"rgb(" + room.color + ")"}
                      >
                        rgb({room.color})
                      </div>
                      <div
                        className="text-truncate col"
                        title={room.camera_Direction}
                      >
                        {room.camera_Direction}
                      </div>
                      <div
                        className="text-truncate col"
                        title={room.front_Desc}
                      >
                        {room.front_Desc}
                      </div>
                      <div
                        className="text-truncate col"
                        title={room.right_Desc}
                      >
                        {room.right_Desc}
                      </div>
                      <div className="text-truncate col" title={room.back_Desc}>
                        {room.back_Desc}
                      </div>
                      <div className="text-truncate col" title={room.left_Desc}>
                        {room.left_Desc}
                      </div>

                      {/* Action: Edit Room */}
                      <div
                        className="col p-0 text-truncate text-center"
                        data-bs-toggle="modal"
                        data-bs-target="#updateRoom"
                        onClick={() => setRoom(room.id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          height="24px"
                          viewBox="0 0 24 24"
                          width="24px"
                          fill={edit === room.id ? "#6ccfe9" : "currentColor"}
                          onMouseEnter={() => {
                            setEdit(room.id);
                          }}
                          onMouseLeave={() => {
                            setEdit(null);
                          }}
                          className="cursor-pointer"
                          onClick={() => {
                            // dispatch(setFloor(floor));
                            // navigate("/admin/floors/edit");
                          }}
                        >
                          <path d="M0 0h24v24H0V0z" fill="none" />
                          <path d="M3 17.46v3.04c0 .28.22.5.5.5h3.04c.13 0 .26-.05.35-.15L17.81 9.94l-3.75-3.75L3.15 17.1c-.1.1-.15.22-.15.36zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z" />
                        </svg>
                        {/* Action: Delete Room */}
                        {/* <div
                        className="col"
                        data-bs-toggle="modal"
                        data-bs-target="#deleteRoom"
                        onClick={() => setRoom(room.id)}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          fill="currentColor"
                          class="bi bi-trash-fill cursor-pointer"
                          viewBox="0 0 16 16"
                        >
                          <path d="M2.5 1a1 1 0 0 0-1 1v1a1 1 0 0 0 1 1H3v9a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V4h.5a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H10a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1H2.5zm3 4a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 .5-.5zM8 5a.5.5 0 0 1 .5.5v7a.5.5 0 0 1-1 0v-7A.5.5 0 0 1 8 5zm3 .5v7a.5.5 0 0 1-1 0v-7a.5.5 0 0 1 1 0z" />
                        </svg>
                      </div> */}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </Fragment>
  );
};

export default RoomList;
